/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { MediaItemUrl } from '../../models/media-item-url';

export interface MediaControllerGetUrl$Params {
  name: string;
}

export function mediaControllerGetUrl(http: HttpClient, rootUrl: string, params: MediaControllerGetUrl$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: MediaItemUrl;
}>> {
  const rb = new RequestBuilder(rootUrl, mediaControllerGetUrl.PATH, 'get');
  if (params) {
    rb.path('name', params.name, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: MediaItemUrl;
      }>;
    })
  );
}

mediaControllerGetUrl.PATH = '/multimedia/url/{name}';
